import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';

@Component({
  selector: 'lib-search-field',
  standalone: true,
  imports: [CommonModule,MatFormFieldModule,MatInputModule,FormsModule,ReactiveFormsModule],
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss'
})
export class SearchFieldComponent {
  @Output() applySearch = new EventEmitter<Event>();
  search:any;

  searchData(event: any) {   
    this.applySearch.emit(event);
  }
}
